import BaseModule from '../../../javascripts/helpers/baseModule';

const disabledAnimations = () => {
  return localStorage.getItem('animationsEnabled') === 'false' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
export default class MovingGradient extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'), []);
  }

  init() {
    this.mousePosition = { x: 0, y: 0 };
    this.paralaxMultiplier = 200;
    const red = '249, 78, 47';
    const blue = '140, 197, 208';
    this.blobs = [
      { color: blue, depth: 0.15 },
      { color: blue, depth: 0.15 },
      { color: blue, depth: 0.15 },
      { color: blue, depth: 0.15 },
      { color: blue, depth: 0.3 },
      { color: blue, depth: 0.4 },
      { color: blue, depth: 0.5 },
      { color: blue, depth: 0.6 },
      { color: blue, depth: 0.7 },
      { color: red, depth: 0.8 },
      { color: red, depth: 0.8 },
      { color: red, depth: 1 }
    ];

    this.animationsEnabled = !disabledAnimations();
    if (!this.animationsEnabled) {
      this.elements.self.classList.add('prefers-reduced-motion');
    }

    window.addEventListener('animationsEnabled', (event) => {
      this.animationsEnabled = event.detail;
      if (this.animationsEnabled) {
        this.elements.self.classList.remove('prefers-reduced-motion');
        this.startAnimation();
      } else {
        this.elements.self.classList.add('prefers-reduced-motion');
        if (this.animationTimeout) {
          clearTimeout(this.animationTimeout);
        }
      }
    });

    this.createGooElements();
    this.startAnimation();
    this.setupMouseTracking();
  }

  setupMouseTracking() {
    if (!window.matchMedia('(pointer: fine)').matches) {
      return; // we are on mobile, no mouse stuff for you guys... sry!
    }

    if (!this.animationsEnabled) {
      return;
    }

    const mouseFollower = this.gooElements[this.gooElements.length - 1];
    mouseFollower.classList.add('mouseFollower');

    window.addEventListener('mousemove', (e) => {
      if (!this.animationsEnabled) return;

      const containerRect = this.elements.self.getBoundingClientRect();

      // Convert mouse position to be relative to center of window (-1 to 1 range)
      this.mousePosition = {
        x: e.clientX / window.innerWidth,
        y: e.clientY / window.innerHeight
      };
      this.updateParallax();

      const isMouseInContainer =
        e.clientX >= containerRect.left && e.clientX <= containerRect.right && e.clientY >= containerRect.top && e.clientY <= containerRect.bottom;

      // update mouseFollower
      if (isMouseInContainer) {
        const mouseX = e.clientX - containerRect.left;
        const mouseY = e.clientY - containerRect.top;
        const percentX = (mouseX / this.elements.self.offsetWidth) * 100;
        const percentY = (mouseY / this.elements.self.offsetHeight) * 100;

        mouseFollower.style.setProperty('--top', `${percentY}%`);
        mouseFollower.style.setProperty('--left', `${percentX}%`);
        mouseFollower.style.setProperty('--opacity', Math.random() * 0.4 + 0.6);
        mouseFollower.style.setProperty('--circleSize', `${Math.random() * 20 + 60}%`);

        mouseFollower.classList.add('mouseFollower');
      } else if (mouseFollower.classList.contains('mouseFollower')) {
        mouseFollower.classList.remove('mouseFollower');
        mouseFollower.style.setProperty('--top', `${Math.random() * 100}%`);
        mouseFollower.style.setProperty('--left', `${Math.random() * 100}%`);
      }
    });
  }

  createGooElements() {
    this.gooElements = this.blobs.map((blob) => {
      const goo = document.createElement('div');
      goo.className = 'moving-gradient__goo';
      goo.style.setProperty('--color', blob.color);
      goo.style.setProperty('--top', `${Math.random() * 100}%`);
      goo.style.setProperty('--left', `${Math.random() * 100}%`);
      goo.style.setProperty('--circleSize', `${Math.random() * 20 + 60}%`);
      goo.style.setProperty('--opacity', 0);
      goo.style.setProperty('--translateX', '0px');
      goo.style.setProperty('--translateY', '0px');

      this.elements.self.querySelector('.moving-gradient__gradients-container').appendChild(goo);
      return goo;
    });
  }

  updateParallax() {
    if (!this.animationsEnabled) return;

    // Update all elements except the last one (mouse follower)
    this.gooElements.slice(0, -1).forEach((goo, index) => {
      const { depth } = this.blobs[index];
      const moveX = this.mousePosition.x * this.paralaxMultiplier * depth;
      const moveY = this.mousePosition.y * this.paralaxMultiplier * depth;
      goo.style.setProperty('--translateX', `${moveX}px`);
      goo.style.setProperty('--translateY', `${moveY}px`);
    });
  }

  startAnimation() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }

    const animate = () => {
      this.gooElements.forEach((goo) => {
        if (!goo.classList.contains('mouseFollower')) {
          const top = Math.random() * 100;
          const left = Math.random() * 100;
          goo.style.setProperty('--top', `${top}%`);
          goo.style.setProperty('--left', `${left}%`);
          goo.style.setProperty('--opacity', Math.random() * 0.4 + 0.6);
          goo.style.setProperty('--circleSize', `${Math.random() * 20 + 60}%`);
        }
      });

      if (!this.animationsEnabled) {
        this.animationTimeout = setTimeout(() => requestAnimationFrame(animate), 10_000);
      }
    };

    this.animationTimeout = setTimeout(() => {
      requestAnimationFrame(animate);
    }, 100);
  }
}
